module.exports = __webpack_public_path__ + "static/img/article_01.8abd464.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2024/galaxy_award/article_01.png
// module id = V3SV
// module chunks = 0